import { useEffect, useState } from 'react';
import { quotesAPI } from 'services/swagger-api';

/**
 * Vrai si ce devis porte son propre mandat SEPA.
 *
 * Hors contrat collectif, toujours vrai. Pour un aliment, c'est le paramétrage du contrat
 * cadre qui tranche : faux quand le souscripteur règle pour tous les aliments. Le mandat
 * est alors signé au niveau du cadre, et l'aliment n'a ni compte à débiter ni mandat à
 * faire signer — proposer les comptes de l'assuré ferait partir le prélèvement du mauvais
 * compte.
 *
 * Le champ est désormais porté par la réponse de contractualisation : quand il est là, on
 * le lit et rien n'est appelé. Le repli sur `GET /devis/{id}/mandat` ne sert qu'aux
 * environnements pas encore redéployés, qui ne le renvoient pas encore — sans lui, l'écran
 * y régresserait sur le KO qu'on vient de corriger. Il s'éteint de lui-même au déploiement,
 * et pourra alors être retiré.
 *
 * En cas d'échec du repli on répond `true`, c'est-à-dire l'affichage d'avant : masquer à
 * tort une étape de signature légitime bloquerait la contractualisation, alors que
 * l'afficher à tort reste rattrapé par le refus du back sur `PUT /devis/{id}/mandat`.
 */
export const useRequiresOwnMandate = (
  quoteId: string | undefined,
  fromPageData: boolean | undefined
): boolean => {
  const [fallback, setFallback] = useState(true);

  const needsFallback = fromPageData === undefined;

  useEffect(() => {
    if (!needsFallback || !quoteId) return;

    let isCurrent = true;
    setFallback(true);

    quotesAPI
      .getMandateByQuoteId({ quoteId })
      .then((mandate) => {
        if (isCurrent) setFallback(mandate?.requiresOwnMandate ?? true);
      })
      .catch((error) => {
        console.error('Lecture du mandat impossible', error);
      });

    return () => {
      isCurrent = false;
    };
  }, [needsFallback, quoteId]);

  return fromPageData ?? fallback;
};
